<template>
  <div>
    <div v-for="game in games" :key="game.ID" class="py-2 tour-link">
      <div class="d-flex">
        <!-- время + статус -->
        <div class="flex-shrink-1 align-self-center text-left game-time-block">
          <div class="font-weight-normal time-start-game text-white">{{game.Time}}</div>
          <div class="small game-online"
               :class="[game.State === 'live' ? dataSport.textClass : 'text-white-50 state-small']">
            {{game.State}}
          </div>
        </div>

        <!-- команды -->
        <div class="pl-2 w-100">
          <div class="d-flex justify-content-center align-items-center">
            <!-- команда 1 -->
            <div class="text-right w-100">
              <div class="font-weight-normal team-font-size small text-white" v-if="$i18n.locale === 'ru'">
                {{game.team1_title}}
              </div>
              <div class="font-weight-normal team-font-size small text-white" v-else>
                {{game.team1_title_eng}}
              </div>
              <div class="small text-white-50" v-if="$i18n.locale === 'ru'">{{game.player1_title}}</div>
              <div class="small text-white-50" v-else>{{game.player1_title_eng}}</div>
            </div>

            <!-- счет -->
            <div class="px-3 game-score text-center d-flex align-items-center">
              <div>
                <div v-if="game.ScoreTeam1 > game.ScoreTeam2" class="text-nowrap">
                  <span v-if="game.TeamOvertimeWin > 0 && game.Team1_id === game.TeamOvertimeWin" :class="dataSport.textClass">OT&nbsp;</span>
                  <span :class="dataSport.textClass">{{game.ScoreTeam1}}</span>
                  <span class="separator text-white">-</span>
                  <span class="text-white">{{game.ScoreTeam2}}</span>
                  <span v-if="game.TeamOvertimeWin > 0 && game.Team2_id === game.TeamOvertimeWin" :class="dataSport.textClass">&nbsp;OT</span>
                </div>
                <div v-else-if="game.ScoreTeam1 < game.ScoreTeam2" class="text-nowrap">
                  <span v-if="game.TeamOvertimeWin > 0 && game.Team1_id === game.TeamOvertimeWin" :class="dataSport.textClass">OT&nbsp;</span>
                  <span class="text-white">{{game.ScoreTeam1}}</span>
                  <span class="separator text-white">-</span>
                  <span :class="dataSport.textClass">{{game.ScoreTeam2}}</span>
                  <span v-if="game.TeamOvertimeWin > 0 && game.Team2_id === game.TeamOvertimeWin" :class="dataSport.textClass">&nbsp;OT</span>
                </div>
                <div v-else-if="game.ScoreTeam1 === game.ScoreTeam2 && game.State !== 'upcoming'" class="text-nowrap">
                  <span v-if="game.TeamBullitsWin > 0 && game.Team1_id === game.TeamBullitsWin" :class="dataSport.textClass">Б&nbsp;</span>
                  <span class="text-white">{{game.ScoreTeam1}}</span>
                  <span class="separator text-white">-</span>
                  <span class="text-white">{{game.ScoreTeam2}}</span>
                  <span v-if="game.TeamBullitsWin > 0 && game.Team2_id === game.TeamBullitsWin" :class="dataSport.textClass">&nbsp;Б</span>
                </div>
                <div v-else class="text-nowrap">
                  <b class="separator text-white">-</b>
                </div>
              </div>
            </div>

            <!-- команда 2 + тултип -->
            <div class="text-left w-100 d-flex align-items-center">
              <div>
                <div class="font-weight-normal team-font-size small text-white" v-if="$i18n.locale === 'ru'">
                  {{game.team2_title}}
                </div>
                <div class="font-weight-normal team-font-size small text-white" v-else>
                  {{game.team2_title_eng}}
                </div>
                <div class="small text-white-50" v-if="$i18n.locale === 'ru'">{{game.player2_title}}</div>
                <div class="small text-white-50" v-else>{{game.player2_title_eng}}</div>
              </div>

              <div v-if="game.ResultType" class="tooltip-container ml-2">
                <span class="tooltip-icon">
                  <img :src="svgPath" alt="info icon" />
                </span>
                <div class="tooltip-message tooltip-right">
                  {{ getResultTypeMessage(game.ResultType) }}
                </div>
              </div>
            </div>
          </div>

          <!-- периоды -->
          <div class="text-nowrap text-center periods-block">
            <small class="text-white">{{game.Periods}}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StageGames",
  props: ["games", "dataSport"],
  data() {
    return {
      svgPath: require("@/assets/img/info-circle.svg"),
    };
  },
  methods: {
    getShortResultType(ResultType) {
      const shortTypes = {
        KO: "КО",
        TKO: "ТКО",
        SUB: "SUB",
        UDEC: "UDEC",
        SDEC: "SDEC",
        MDEC: "MDEC",
        DEC: "WIN",
        DRAW: "DRAW",
      };
      return shortTypes[ResultType] || "";
    },
    getResultTypeMessage(ResultType) {
      const messages = {
        KO: this.$i18n.locale === "ru" ? "Нокаут" : "Knockout",
        TKO: this.$i18n.locale === "ru" ? "Технический нокаут" : "Technical knockout",
        SUB: this.$i18n.locale === "ru" ? "Сдача" : "Submission",
        UDEC: this.$i18n.locale === "ru" ? "Единогласное решение" : "Unanimous decision",
        SDEC: this.$i18n.locale === "ru" ? "Раздельное решение" : "Split decision",
        MDEC: this.$i18n.locale === "ru" ? "Решение большинства" : "Majority decision",
        DEC: this.$i18n.locale === "ru" ? "Решение судей" : "Decision",
        DRAW: this.$i18n.locale === "ru" ? "Ничья" : "Draw",
      };
      return messages[ResultType] || "";
    },
  },
};
</script>

<style scoped>
.separator {
  font-size: 17px;
  font-weight: 400;
  padding: 0 2px;
}
.game-time-block {
  max-width: 60px;
  width: 100%;
}
.game-online {
  letter-spacing: 1px;
  font-size: 0.8rem;
}
.state-small {
  font-size: 0.7rem;
}
.periods-block {
  line-height: 12px;
}

/* Тултип */
.tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.tooltip-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.tooltip-icon img {
  width: 16px;
  height: 16px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.tooltip-icon:hover img {
  opacity: 1;
}
.tooltip-message {
  visibility: hidden;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.75rem;
  white-space: nowrap;
  width: max-content;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.tooltip-right {
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  margin-left: 6px;
}
.tooltip-container:hover .tooltip-message {
  visibility: visible;
}
</style>
